import { cn } from "@gettactic/helpers";
import {
  CardV2LayoutClasses,
  CardV2LayoutNoShadowClasses
} from "@cmp-src/data-display/Card/classes";
import { Heading } from "@cmp-src/data-display/Heading/Heading";
import React from "react";

export interface CardProps
  extends React.PropsWithChildren<
    Omit<React.HTMLProps<HTMLDivElement>, "title" | "className" | "action">
  > {
  /** Lifts the card with a shadow on desktop. Default true. */
  hasShadow?: boolean;
  /** The card title, an `h3`. */
  title?: React.ReactNode;
  /** A control on the right of the title. */
  action?: React.ReactNode;
  className?: string;
  /** Props of the content wrapper. */
  contentProps?: React.HTMLProps<HTMLDivElement>;
  titleWrapperClassName?: string;
  /** Drops the card surface, for a card inside another. */
  isFlat?: boolean;
}

const classes = {
  Wrapper: "p-3",
  HasShadow: "md:shadow-componentCard",
  TitleWrapper:
    "flex justify-between items-center text-neutral-1000 text-lg mb-1 px-2 py-3",
  Title: "",
  Content: "p-2"
};

/** A dashboard card: a title with an optional action, above the content. */
export const Card: React.FC<CardProps> = ({
  children,
  hasShadow = true,
  title,
  action,
  className,
  contentProps,
  titleWrapperClassName = "",
  isFlat = false,
  ...rest
}) => {
  return (
    <div
      className={cn(
        classes.Wrapper,
        hasShadow && classes.HasShadow,
        !isFlat
          ? hasShadow
            ? CardV2LayoutClasses
            : CardV2LayoutNoShadowClasses
          : "",
        className
      )}
      {...rest}
    >
      {(title || action) && (
        <div className={cn(classes.TitleWrapper, titleWrapperClassName)}>
          {title ? (
            <Heading as={"card"} className={"min-w-0 flex-1"}>
              {title}
            </Heading>
          ) : (
            <div />
          )}
          {action ? <div>{action}</div> : null}
        </div>
      )}
      <div
        {...contentProps}
        className={cn(classes.Content, contentProps?.className)}
      >
        {children}
      </div>
    </div>
  );
};
